export default __webpack_public_path__ + "static/media/summerPrograms.c467b63d.jpg";